/**
 * PMO #23381 / #23351 opción [B] — el API ahora corta con 403 CONSENT_REQUIRED las generaciones de texto y de
 * imagen de quien no consintió (Ley 172-13 Art. 5.4). El front tiene que reconocer ese error, abrir el modal de
 * consentimiento y reintentar, en vez de mostrar «Error generando texto».
 *
 * Tres formas en que llega el mismo error (contrato de BACKEND, PR #2936):
 *  1. HTTP 403 en axios: el filtro de excepciones sube `code` al nivel superior del cuerpo (y lo deja en details.code).
 *  2. /ai/text-generation/stream: la cabecera ya salió con 200, así que viaja como evento SSE
 *     `data: {"error": "...", "status": 403, "code": "CONSENT_REQUIRED"}`.
 *  3. Un error nuestro que ya trae `code` (lo que lanza el cliente de streaming al leer ese evento).
 *
 * Solo CONSENT_REQUIRED abre el modal. Una cuota agotada (QUOTA_EXCEEDED_*, PURPOSE_NOT_IN_PLAN) también es 403
 * pero aceptar el consentimiento no la arregla: ésas siguen mostrándose como error.
 */

export const CONSENT_REQUIRED = 'CONSENT_REQUIRED';

export const esConsentimientoRequerido = (err: unknown): boolean => {
  if (!err || typeof err !== 'object') return false;
  const e = err as {
    code?: unknown;
    status?: unknown;
    response?: { status?: unknown; data?: { code?: unknown; details?: { code?: unknown } } };
  };
  const codigo = e.response?.data?.code ?? e.response?.data?.details?.code ?? e.code;
  const status = e.response?.status ?? e.status;
  return codigo === CONSENT_REQUIRED && (status === 403 || status === undefined);
};

/** Lo que recibe quien llamó cuando la persona cierra el modal sin aceptar. */
export class ConsentRejectedError extends Error {
  readonly code = 'CONSENT_REJECTED';
  constructor() {
    super('Para usar la IA necesitamos tu consentimiento. Puedes darlo cuando quieras y volver a intentarlo.');
    this.name = 'ConsentRejectedError';
  }
}
